var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPps(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66013_52745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9973 5.02377C12.997 4.79031 12.9354 4.56102 12.8186 4.35889C12.7017 4.15677 12.5338 3.98893 12.3316 3.8722L7.67209 1.20961C7.46971 1.09276 7.24014 1.03125 7.00645 1.03125C6.77276 1.03125 6.54318 1.09276 6.3408 1.20961L1.68127 3.8722C1.47909 3.98893 1.31116 4.15677 1.19433 4.35889C1.07749 4.56102 1.01586 4.79031 1.01562 5.02377V10.3489C1.01586 10.5824 1.07749 10.8117 1.19433 11.0138C1.31116 11.2159 1.47909 11.3838 1.68127 11.5005L6.3408 14.1631C6.54318 14.2799 6.77276 14.3415 7.00645 14.3415C7.24014 14.3415 7.46971 14.2799 7.67209 14.1631L12.3316 11.5005C12.5338 11.3838 12.7017 11.2159 12.8186 11.0138C12.9354 10.8117 12.997 10.5824 12.9973 10.3489V5.02377Z",
    stroke: "black",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22656 4.375L7.01769 7.70323L12.8088 4.375",
    stroke: "black",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02344 14.3362V7.67969",
    stroke: "black",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0389 15.3824C13.8035 15.3824 15.234 13.9519 15.234 12.1873C15.234 10.4227 13.8035 8.99219 12.0389 8.99219C10.2742 8.99219 8.84375 10.4227 8.84375 12.1873C8.84375 13.9519 10.2742 15.3824 12.0389 15.3824Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3486 11.2734L11.5513 13.0707L10.7344 12.2538",
    stroke: "black",
    strokeWidth: 1.24809,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66013_52745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9755,
    height: 15.9755,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPps);
export default __webpack_public_path__ + "static/media/pps.17cdf96328bad47b2d827a930fb89355.svg";
export { ForwardRef as ReactComponent };